export default __webpack_public_path__ + "static/media/400.f9a7862b.jpg";